module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGUlEQVR4nGPwtjX6TwlmGDVg1IBRA4aLAQD38rkQ3RvnNgAAAABJRU5ErkJggg=="